// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-wrapper {
    position: relative;
    -webkit-user-select: none;
            user-select: none;
    min-width: 228px;
    margin-left: 15px;
}
@media (max-width: 580px) {
    .responsive_select {
        min-width: 128px;
    }
}
.custom-select {
    position: relative;
    display: flex;
    flex-direction: column;
}
.custom-select__trigger {
    position: relative;
    padding: 0 12px;
    font-size: 16px;
    font-weight: 600;
    height: 40px;
    background-color: #FD552B;
    color: #ffffff;
    cursor: pointer;
    border-radius: 7px;
}
.custom-options {
    padding-top: 10px;
    position: absolute;
    display: block;
    top: 100%;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);
    left: 0;
    right: 0;
    border-top: 0;
    background: #fff;
    transition: all 0.5s;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 2000;
}
.custom-select.open .custom-options {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
}

@media (max-width: 600px) {
    .custom-options {
        z-index: 700;
        visibility: visible;
    }
}

.permission_custom_menu {
    width: 620px;
    background-color: white;
    position: absolute;
    border: 1px solid #D7D7DE;
    padding: 10px;
    right: -275%;
}
@media (max-width: 1250px) {
    .permission_custom_menu {
        right: 0px;
        top: 250px;
    }
}
@media (max-width: 580px) {
    .permission_custom_menu {
        top: 320px;
        right: 0%;
        width: 180%;


    }
}
.permission_custom_menu_left {
    width: 620px;
    background-color: white;
    position: absolute;
    border: 1px solid #D7D7DE;
    padding: 10px;
    right: -275%;
}
.perm_menu_link {
    color: #0E0A40;
    text-decoration: underline;
    cursor: pointer;
}
.perm_menu_box {
    display: grid;
    grid-template-columns: 70% 30%;
    margin-bottom: 1rem;
}
.perm_menu_box > div > h4 {
    font-size: 14px;
    color: black;
}
.perm_menu_box > div > p {
    font-size: 12px;
    color: #b0abab;
    line-height: 20px;
    padding-top: 2px;
    padding-bottom: 2px;
}
.perm_radio {
    margin-left: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

@media(max-width:600px){
    .perm_radio{
        margin-right: -6px;
    }
}

.custom-option {
    position: relative;
    display: block;
    padding: 0 12px 0 12px;
    font-size: 14px;
    font-weight: 300;
    color: #3b3b3b;
    line-height: 30px;
    cursor: pointer;
    transition: all 0.4s;
}
.custom-option:hover {
    cursor: pointer;
    background-color: #e0d7d7;
}
.custom-option.selected {
    color: #ffffff;
    background-color: #305c91;
}
.select-arrow {
    width: 15px;
    transition: 0.4s;
}
.select-arrow-up {
    width: 15px;
    transition: 0.4s;
    transform: rotateX(-180deg);
}

.permission_select_trigger {
    background-color: white;
    border: 1px solid rgba(14, 10, 64, 0.5);
    position: relative;
    padding: 0 12px;
    font-size: 16px;
    font-weight: 600;
    height: 40px;
    color: black;
    cursor: pointer;
    border-radius: 3px;
}

@media(max-width:600px){
    .permission_select_trigger{
        right: 30px;
    }
}


.permission_select_trigger > span {
    font-size: 14px;
    font-weight: 500;
}

.permission_btn_box {
    margin-top: 15px;
    display: grid;
    grid-template-columns: 50% 50%;
    align-items: end;
    padding: 5px;
}
@media (max-width: 580px) {
    .permission_btn_box {
        display: flex;
        flex-direction: column-reverse;
    }
    .text_link {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
}
.text_link {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
}

@media (max-width: 500px) {
    .custom-select-wrapper {
        min-width: 150px;
        margin-left: 5px;
        width: 100%;
        padding: 0 5px;
    }
    .custom-select__trigger {
        font-size: 14px;
        height: 50px;
        padding: 0px 7px;
    }
    .select-arrow {
        width: 10px;
    }
    .select-arrow-up {
        width: 10px;
    }
    .custom-option {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/Select.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,yCAAyC;IACzC,OAAO;IACP,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,YAAY;AAChB;AACA;IACI;QACI,UAAU;QACV,UAAU;IACd;AACJ;AACA;IACI;QACI,UAAU;QACV,SAAS;QACT,WAAW;;;IAGf;AACJ;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,YAAY;AAChB;AACA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;QACX,cAAc;IAClB;IACA;QACI,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".custom-select-wrapper {\n    position: relative;\n    user-select: none;\n    min-width: 228px;\n    margin-left: 15px;\n}\n@media (max-width: 580px) {\n    .responsive_select {\n        min-width: 128px;\n    }\n}\n.custom-select {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n.custom-select__trigger {\n    position: relative;\n    padding: 0 12px;\n    font-size: 16px;\n    font-weight: 600;\n    height: 40px;\n    background-color: #FD552B;\n    color: #ffffff;\n    cursor: pointer;\n    border-radius: 7px;\n}\n.custom-options {\n    padding-top: 10px;\n    position: absolute;\n    display: block;\n    top: 100%;\n    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);\n    left: 0;\n    right: 0;\n    border-top: 0;\n    background: #fff;\n    transition: all 0.5s;\n    opacity: 0;\n    visibility: hidden;\n    pointer-events: none;\n    z-index: 2000;\n}\n.custom-select.open .custom-options {\n    opacity: 1;\n    visibility: visible;\n    pointer-events: all;\n}\n\n@media (max-width: 600px) {\n    .custom-options {\n        z-index: 700;\n        visibility: visible;\n    }\n}\n\n.permission_custom_menu {\n    width: 620px;\n    background-color: white;\n    position: absolute;\n    border: 1px solid #D7D7DE;\n    padding: 10px;\n    right: -275%;\n}\n@media (max-width: 1250px) {\n    .permission_custom_menu {\n        right: 0px;\n        top: 250px;\n    }\n}\n@media (max-width: 580px) {\n    .permission_custom_menu {\n        top: 320px;\n        right: 0%;\n        width: 180%;\n\n\n    }\n}\n.permission_custom_menu_left {\n    width: 620px;\n    background-color: white;\n    position: absolute;\n    border: 1px solid #D7D7DE;\n    padding: 10px;\n    right: -275%;\n}\n.perm_menu_link {\n    color: #0E0A40;\n    text-decoration: underline;\n    cursor: pointer;\n}\n.perm_menu_box {\n    display: grid;\n    grid-template-columns: 70% 30%;\n    margin-bottom: 1rem;\n}\n.perm_menu_box > div > h4 {\n    font-size: 14px;\n    color: black;\n}\n.perm_menu_box > div > p {\n    font-size: 12px;\n    color: #b0abab;\n    line-height: 20px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n}\n.perm_radio {\n    margin-left: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n@media(max-width:600px){\n    .perm_radio{\n        margin-right: -6px;\n    }\n}\n\n.custom-option {\n    position: relative;\n    display: block;\n    padding: 0 12px 0 12px;\n    font-size: 14px;\n    font-weight: 300;\n    color: #3b3b3b;\n    line-height: 30px;\n    cursor: pointer;\n    transition: all 0.4s;\n}\n.custom-option:hover {\n    cursor: pointer;\n    background-color: #e0d7d7;\n}\n.custom-option.selected {\n    color: #ffffff;\n    background-color: #305c91;\n}\n.select-arrow {\n    width: 15px;\n    transition: 0.4s;\n}\n.select-arrow-up {\n    width: 15px;\n    transition: 0.4s;\n    transform: rotateX(-180deg);\n}\n\n.permission_select_trigger {\n    background-color: white;\n    border: 1px solid rgba(14, 10, 64, 0.5);\n    position: relative;\n    padding: 0 12px;\n    font-size: 16px;\n    font-weight: 600;\n    height: 40px;\n    color: black;\n    cursor: pointer;\n    border-radius: 3px;\n}\n\n@media(max-width:600px){\n    .permission_select_trigger{\n        right: 30px;\n    }\n}\n\n\n.permission_select_trigger > span {\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.permission_btn_box {\n    margin-top: 15px;\n    display: grid;\n    grid-template-columns: 50% 50%;\n    align-items: end;\n    padding: 5px;\n}\n@media (max-width: 580px) {\n    .permission_btn_box {\n        display: flex;\n        flex-direction: column-reverse;\n    }\n    .text_link {\n        margin-top: 1rem;\n        margin-bottom: 1rem;\n    }\n}\n.text_link {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 12px;\n    cursor: pointer;\n}\n\n@media (max-width: 500px) {\n    .custom-select-wrapper {\n        min-width: 150px;\n        margin-left: 5px;\n        width: 100%;\n        padding: 0 5px;\n    }\n    .custom-select__trigger {\n        font-size: 14px;\n        height: 50px;\n        padding: 0px 7px;\n    }\n    .select-arrow {\n        width: 10px;\n    }\n    .select-arrow-up {\n        width: 10px;\n    }\n    .custom-option {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
